import pluralize from "pluralize";
import { type FC, useState } from "react";

import { type ActionButtonProps, DialogComponent } from "widgets";

import { ExpressionColoringFeaturesTrackForm } from "../ExpressionColoringFeaturesTrackForm.js";
import { capitalizeFirstLetterOfAllWords } from "@/app-utils/string.ts";
import { FEATURE_DISPLAY_NAME } from "@/settings/settings.js";

interface IFeatureTrackCustomizationDialogProps {
  trackType: string; // TRACK_TYPE
  onClose: () => void;
}

export interface IFeatureTrackCustomizationDialogState {
  nextButtonProps?: ActionButtonProps;
  resetButton?: ActionButtonProps;
  error?: string;
}

const FeatureTrackCustomizationDialog: FC<IFeatureTrackCustomizationDialogProps> = (props) => {
  const [dialogState, updateDialogState] = useState<IFeatureTrackCustomizationDialogState>({
    nextButtonProps: {
      label: "Apply",
      isDisabled: true,
      onPress: () => {},
    },
  });

  return (
    <DialogComponent
      mainButton={dialogState.nextButtonProps}
      secondaryButton={dialogState.resetButton}
      title={`${capitalizeFirstLetterOfAllWords(pluralize(FEATURE_DISPLAY_NAME[props.trackType]))} Track`}
      subtitle={"Dataset configuration for expression coloring"}
      closeFn={props.onClose}
      errorCallout={{ message: dialogState.error }}
    >
      <ExpressionColoringFeaturesTrackForm
        updateDialogState={updateDialogState}
        trackType={props.trackType}
        onClose={props.onClose}
      />
    </DialogComponent>
  );
};

export default FeatureTrackCustomizationDialog;
